// DPO.js
import React from 'react';
import { Link } from 'react-router-dom';

const DPO = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1 className="card-title">You are ahead of your time</h1>
      <p className="card-text">This feature is currently being built with<br />the expertise of a professional Data Protection Officer.<br />Check back again later!<br /><img src="./pdpc.png" alt="Personal Data Protection Commission" style={{ height: '200px' }} /></p>
      <Link to="/">Go back to Home</Link>
    </div>
  );
};

export default DPO;
